import styled, { css } from 'styled-components';
import { Modal } from 'reactstrap';
import { ifProp, prop } from 'styled-tools';

const WindcreekModal = styled(Modal)`
  ${ifProp(
    'page',
    css`
      position: fixed;
      height: ${prop('page.height')}px;
      top: ${prop('page.scrollY')}px;
      min-height: unset;
      width: 96%;

      /*
      Fade defaults to true, but we have to use !important here
      to override the bootstrap transition, so check the fade prop
      and maintain its transform value if it isn't false.
      */
      &.modal-dialog {
        transition: ${props =>
            props.fade !== false ? 'transform 0.3s ease-out,' : ''}
          top 0.5s !important;
      }
    `
  )}

  .modal-content {
    border-radius: 0;
    border: 0;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
    text-align: center;

    h1 {
      color: ${props => props.theme.modal.headerColor};
    }
  }

  .modal-header {
    border-radius: 0;
    color: #fff;
    background: ${props => props.theme.modal.headerColor};
  }
`;

export default WindcreekModal;
